import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Notifications } from '../../core/model/notifications';
import { IPagination } from '../model/pagination';
import { Alertas } from '../model/alerts';

@Injectable()
export class AlertasService {
  ALERT_PATH = '';

  constructor(private http: HttpClient) {
    this.ALERT_PATH = environment.API_BASE + '/Alertas';
  }

  getAlertsByUser(start: number, numberTake: number): Observable<IPagination<Alertas>> {
    const observable = this.http.get(this.ALERT_PATH + '/Find/' + start + '/' + numberTake)
                                .pipe(map((data: IPagination<Alertas>) =>
                                  IPagination.toModel<Alertas>(JSON.stringify(data), Alertas)));
    return observable as Observable<IPagination<Alertas>>;
  }

  markAlertState(alertId: number, isRead: boolean): Observable<any> {
    return this.http.get<any>(this.ALERT_PATH + '/MarcarComoLeida/' + isRead + '/' + alertId);
  }

  getNotificationsPendingRead(): Observable<Notifications> {
    return this.http.get<Notifications>(this.ALERT_PATH + '/PendienteLeer')
      .pipe(map(response => Notifications.toModel(JSON.stringify(response))));
  }

  removeAlert(alertId: number): Observable<any> {
    return this.http.get<any>(this.ALERT_PATH + '/EliminarAlerta/' + alertId);
  }


}
